import { Product } from '../../types/product';
import { Action, SET_PRODUCTS } from './actions';

export default (state: Product[] = null as any, action: Action): Product[] => {
  switch (action.type) {
    case SET_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
};
